/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PortalsInputs */

const cs_nav_portals = /** @type {(inputs: Nav_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav syncu portálů`)
};

const en_nav_portals = /** @type {(inputs: Nav_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal sync status`)
};

/**
* | output |
* | --- |
* | "Portal sync status" |
*
* @param {Nav_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_portals = /** @type {((inputs?: Nav_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_portals(inputs)
	return cs_nav_portals(inputs)
});